var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDot2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 162,
    viewBox: "0 0 204 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dot",
    filter: "url(#filter0_d_1_4486)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 7.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 7.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 7.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 7.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 45",
    cx: 7.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 7.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 7.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 75",
    cx: 7.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 28.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 28.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 28.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 28.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 46",
    cx: 28.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 56",
    cx: 28.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 28.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 28.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 49.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 49.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    cx: 49.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    cx: 49.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 47",
    cx: 49.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 57",
    cx: 49.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 67",
    cx: 49.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 77",
    cx: 49.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 70.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 70.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 70.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 38",
    cx: 70.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 48",
    cx: 70.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 58",
    cx: 70.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 68",
    cx: 70.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 78",
    cx: 70.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 91.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    cx: 91.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 91.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 39",
    cx: 91.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    cx: 91.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 59",
    cx: 91.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 69",
    cx: 91.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 79",
    cx: 91.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 112.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    cx: 112.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 112.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    cx: 112.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 112.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 60",
    cx: 112.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 112.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 80",
    cx: 112.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 133.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    cx: 133.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    cx: 133.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    cx: 133.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 51",
    cx: 133.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 61",
    cx: 133.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 71",
    cx: 133.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 81",
    cx: 133.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 154.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 154.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    cx: 154.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    cx: 154.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 52",
    cx: 154.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 62",
    cx: 154.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 72",
    cx: 154.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 82",
    cx: 154.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 175.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 175.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    cx: 175.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 43",
    cx: 175.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 53",
    cx: 175.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 63",
    cx: 175.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 73",
    cx: 175.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 83",
    cx: 175.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 196.5,
    cy: 3.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 196.5,
    cy: 24.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 196.5,
    cy: 45.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 44",
    cx: 196.5,
    cy: 66.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 54",
    cx: 196.5,
    cy: 87.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 64",
    cx: 196.5,
    cy: 108.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 74",
    cx: 196.5,
    cy: 129.5,
    r: 3.5,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 84",
    cx: 196.5,
    cy: 150.5,
    r: 3.5,
    fill: "#F4F4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_4486",
    x: 0,
    y: 0,
    width: 204,
    height: 162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4486"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_4486",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot2);
export default __webpack_public_path__ + "static/media/Dot2.b15c471326edf63e26048c34dc6b9406.svg";
export { ForwardRef as ReactComponent };